import {
  CACHE_NAME,
  ERR_NO_CACHE,
  ERR_NO_CACHE_NETWORK,
  ERR_NO_NETWORK,
  FACULTY_DESIGN_API_URL,
} from './config'
import {broadcastError} from './utils'

class API {
  #base = ''
  cache = null
  constructor() {
    this.#base = window.API_URL || 'https://fhp.brandcode.de/api'

    // Early catch of potential cache errors
    const _try_caches = async () => {
      const _open_caches = async () => (await caches.open(CACHE_NAME))
      try {
        return await _open_caches()
      } catch (e) {
        return null
      }
    }
    this.cache = _try_caches()
  }

  _callApi = async (url) => {
    try {
      const _cache = await this.cache

      try {
        // If data could be retrieved, we're saving it in cache before returning it.
        const _network_promise = fetch(url)
        const _network_response = await _network_promise

        if (!_cache) {
          // It seems that implementing a cache-"shim" for FF Incognito works here and we get to the home page,
          // but any faculty selection brings the app into an infinite loop...
          // TODO: Investigate and fix if worth it!
          await broadcastError(ERR_NO_CACHE)
          return []
        }

        await _cache.put(url, _network_response.clone())
        return await _network_response.json()
      } catch (e) {
        // We shouldn't get here without a functional cache
        const _cached_response = await _cache.match(url)
        if (_cached_response) {
          // Data couldn't be retrieved from API, but was found in cache. We're returning that, but notify the user
          await broadcastError(ERR_NO_NETWORK)

          return await _cached_response.json()
        } else {
          // Data couldn't be retrieved from API and was also not found in cache, so we're notifying the user
          await broadcastError(ERR_NO_CACHE_NETWORK)

          // console.error(e)
          console.log('Network problems. Couldn\'t fetch API request data!')
        }
      }
    } catch (e) {
      await broadcastError(ERR_NO_NETWORK)
      // Data couldn't be retrieved from API and was also not found in cache, so we're notifying the user
    }
  }

  getFacultyData = () => (this._callApi(`${this.#base}/faculty`))

  getSemesterData = () => (this._callApi(`${this.#base}/semester`))

  getCourseData = (faculty_id, semester_id) => (this._callApi(`${this.#base}/${faculty_id === 'FLEX' ? 'flex_module' : `course/${faculty_id}`}/${semester_id}`))

  getLectureData = (semester_id, course_id) => (this._callApi(`${this.#base}/lecture/${semester_id}/${course_id}`))

  getDesignFacultyData = () => (this._callApi(FACULTY_DESIGN_API_URL))
}

const api = new API()
export default api
